module.exports = __webpack_public_path__ + "static/media/fun.a8543cbe.png";